/*
 * Copyright 2017-2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */

<template>
  <div v-bind:class="`${amplifyUI.formSection} sign-in-section sign-up-section ${errored ? 'errored' : 'normal'}`" v-bind:data-test="auth.signUp.section">
    <div v-bind:class="amplifyUI.sectionHeader" v-bind:data-test="auth.signUp.headerSection">{{this.options.header}}</div>
    <div v-bind:class="amplifyUI.sectionBody" v-bind:data-test="auth.signUp.bodySection">
      <div v-bind:class="`${amplifyUI.formField} signup-field`"
          v-for="signUpField in this.orderedSignUpFields"
          :signUpField="signUpField.key"
          v-bind:key="signUpField.key"
        >
        <div v-if="emailLogin"  v-on="signUpField.key == 'username' ? { click: generateName } : {}"  v-tooltip="signUpField.key == 'username' ? 'Choose a personal username or click here to generate a random username' : ''" v-bind:data-test="`label-${signUpField.key}`" v-bind:class="`${amplifyUI.inputLabel} label-${signUpField.key} signup-label`">{{signUpField.label}} {{signUpField.required ? '': ''}}</div>
        <!--
        <input
            v-if="signUpField.key !== 'phone_number' && signUpField.key !== 'password'"
            :type = "signUpField.type"
            v-bind:class="[amplifyUI.input, signUpField.invalid ? 'invalid': '']"
            v-model="signUpField.key === 'email' ? email : signUpField.key === 'username' ? username : signUpField.value"
            :placeholder="signUpField.label"
            v-on:change="signUpField.key === 'email'  ? signUpField.value = email : signUpField.key === 'username' ? signUpField.value = username : clear(signUpField)"
            v-bind:data-test="auth.signUp.nonPhoneNumberInput"
          />
          -->
					<input spellcheck="false" v-if="signUpField.key === 'username'"
						v-model="username"
            :type = "signUpField.type"
            v-bind:class="[amplifyUI.input, signUpField.invalid ? 'invalid': '']"
            v-on:changes="signUpField.value = username"
            v-on:dblclick="generateName"
            :placeholder="'double-click to generate a random username'"
            v-bind:data-test="auth.signUp.nonPhoneNumberInput"
					/>
					<input spellcheck="false" v-if="signUpField.key === 'email'"
						v-model="email"
            :type = "signUpField.type"
            v-bind:class="[amplifyUI.input, signUpField.invalid ? 'invalid': '']"
            v-on:changes="signUpField.value = email"
            :placeholder="signUpField.label"
            v-bind:data-test="auth.signUp.nonPhoneNumberInput"
					/>
					<password v-if="signUpField.key === 'password'"
						v-model="password"
            :type = "signUpField.type"
            v-on:changes="signUpField.value = password"
						:class="signUpField.invalid ? 'invalid': ''"
            v-bind:data-test="auth.signUp.nonPhoneNumberInput"
						:secureLength="8"
            :placeholder="signUpField.label"
						:toggle="false"
						:autocomplete="'off'"
					/>
          <!--
        <div v-if="signUpField.key === 'phone_number'" v-bind:class="['countryCode', amplifyUI.selectInput]">
          <select v-model="country" v-bind:data-test="auth.signUp.dialCodeSelect">
            <option v-for="country in countries" v-bind:key="country.label">{{country.label}}</option>
          </select>
          <input
            v-bind:class="['phoneNumber', amplifyUI.input, signUpField.invalid ? 'invalid': '']"
            v-model="signUpField.value"
            type="number"
            :placeholder="signUpField.key === 'phone_number' ? 'for PW recovery/2FA' : signUpField.label"
            v-on:change="clear(signUpField)"
            v-bind:data-test="auth.signUp.phoneNumberInput"
          />
        </div>
        -->
      </div>
    </div>
    <div v-bind:class="amplifyUI.sectionFooter" v-bind:data-test="auth.signUp.footerSection">
      <span v-bind:class="amplifyUI.sectionFooterPrimaryContent">
        <button :disabled="buttonDisabled"  v-bind:class="amplifyUI.button" v-on:click="signUp" v-bind:data-test="auth.signUp.createAccountButton">
          <geno-spinner :loading="flow" :text="$Amplify.I18n.get('Create Account')" :size="32"></geno-spinner></button>
      </span>
      <span v-bind:class="`${amplifyUI.sectionFooterSecondaryContent} sign-up-sign-in`">
        {{$Amplify.I18n.get('Have an account? ')}}
        <a v-bind:class="amplifyUI.a" v-on:click="signIn" v-bind:data-test="auth.signUp.signInLink">{{$Amplify.I18n.get('Sign in')}}</a>
      </span>
    </div>
    <div class="error" v-if="false">
      {{ error }}
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import Vue2Filters from 'vue2-filters'
import orderBy from 'lodash.orderby';
import AmplifyEventBus from '../../events/AmplifyEventBus';
import * as AmplifyUI from '@aws-amplify/ui';
import countries from '../../assets/countries';
import { auth } from '../../assets/data-test-attributes';
import  { remove } from './remove.js'
const Password = () => import('@/components/PasswordStrengthMeter.vue')
let bilbo = require('./bilbo.json');
let bilbo2 = require('./newbilbo.json');
bilbo = bilbo.concat(bilbo2)

const { uniqueNamesGenerator, NumberDictionary, adjectives, colors, starWars } = require('unique-names-generator');
const NumberWords = ["first", "second", "third", "fourth", "fifth", "sixth", "seventh", "eight", "ninth", "tenth"]
function flipCoin(head, tails) {  
    let x = (Math.floor(Math.random() * 2) == 0);
    if(x){
    	return(head);
    }else{
      return(tails);
    }
};

Vue.use(Vue2Filters)

export default {
  name: 'SignUp',
  props: ['signUpConfig'],
  data () {
    return {
      country: 'USA (+1)',
      emailLogin: false,
      countryCode: '1',
      errored: false,
			password: '',
			username: '',
			email: '',
      countries,
      flow: false,
      auth,
      amplifyUI: AmplifyUI,
      error: "passwords require mixed case letters, numbers and a special character, minimum length is 8",
      logger: {},
    }
  },
  components: { Password },
  computed: {
    options() {
      const defaults = {
        header: 'or use your Email to Sign Up',
        signUpFields: [
          {
            label: this.$Amplify.I18n.get('Username'),
            key: 'username',
            required: true,
            type: 'text',
            displayOrder: 1,
          },
          {
            label: this.$Amplify.I18n.get('Password'),
            key: 'password',
            required: true,
            type: 'password',
            displayOrder: 2,
          },
          {
            label: this.$Amplify.I18n.get('Email'),
            key: 'email',
            required: true,
            type: 'text',
            displayOrder: 3
          },
          //{ label: this.$Amplify.I18n.get('Phone Number') + ' (optional)', key: 'phone_number', required: false, displayOrder: 4 }
        ]
      }

      // sets value in country code dropdown if defaultCountryCode value is present in props 
      if (this.signUpConfig && this.signUpConfig.defaultCountryCode) {
        this.country = this.countries.find(c => c.value === this.signUpConfig.defaultCountryCode).label;
      };

      if (this.signUpConfig && this.signUpConfig.hiddenDefaults && this.signUpConfig.hiddenDefaults.length > 0){
        defaults.signUpFields = defaults.signUpFields.filter((d) => {
          return !this.signUpConfig.hiddenDefaults.includes(d.key);
        });
      }

      // begin looping through signUpFields
      if (this.signUpConfig && this.signUpConfig.signUpFields && this.signUpConfig.signUpFields.length > 0) {
        // if hideAllDefaults and hideDefaults are not present on props...
        if (!this.signUpConfig.hideAllDefaults && !this.signUpConfig.hideDefaults) {
          // ...add default fields to signUpField array unless user has passed in custom field with matching key
          defaults.signUpFields.forEach((f, i) => {
            const matchKey = this.signUpConfig.signUpFields.findIndex((d) => {
              return d.key === f.key;
            });
            if (matchKey === -1) {
              this.signUpConfig.signUpFields.push(f);
            }
          });
        }
        /* 
          sort fields based on following rules:
          1. Fields with displayOrder are sorted before those without displayOrder
          2. Fields with conflicting displayOrder are sorted alphabetically by key
          3. Fields without displayOrder are sorted alphabetically by key
        */
        this.signUpConfig.signUpFields.sort((a, b) => {
          if (a.displayOrder && b.displayOrder) {
            if (a.displayOrder < b.displayOrder) {
              return -1;
            } else if (a.displayOrder > b.displayOrder) {
              return 1;
            } else {
              if (a.key < b.key) {
                return -1;
              } else {
                return 1;
              }
            }
          } else if (!a.displayOrder && b.displayOrder) {
            return -1;
          } else if (a.displayOrder && !b.displayOrder) {
            return 1;
          } else if (!a.displayOrder && !b.displayOrder) {
            if (a.key < b.key) {
              return 1;
            } else {
              return -1;
            }
          }
        });
      }
      
      return Object.assign(defaults, this.signUpConfig || {})
    },
    buttonDisabled() {
    let enabled = this.username && this.username.length >= 4 && this.email && this.email.split('@').length > 1 && this.email.split('@')[1].length >4 && this.password && this.password.length >= 8
    if ( enabled ) {
    return false;
    } else{
    return true;
    }
    },
    orderedSignUpFields: function () {
      return orderBy(this.options.signUpFields, 'displayOrder', 'name')
    }
  },
  mounted() {
    AmplifyEventBus.$emit('loginErrors', {source: 'signUp', error: this.error})
    this.logger = new this.$Amplify.Logger(this.$options.name);
                    this.starWars = starWars;
                    this.adjectives = adjectives;
                    this.bilbo = bilbo;
                    this.NumberWords = NumberWords;
  },
  watch: {
    /*
    this operation is in place to avoid making country.value the select box
    bound key, which results in a duplicate key error in console
    */
    country: function() {
      this.countryCode = this.countries.find(c => c.label === this.country).value
    },
  },
  methods: {
    generateName() {
										let dict = flipCoin('bilbo', 'starWars')
										let dict2 = flipCoin('adjectives', 'NumberWords')
                    dict2 = 'adjectives'
                    let testName = uniqueNamesGenerator({
                        dictionaries: dict2 == 'adjectives' ? [this[dict2], this[dict]] : [this[dict], ['The'], this[dict2]],
                        length: dict2 == 'adjectives' ?  2 : 3,
                        separator: '',
                        style: 'capital'
                    })
										this.username = remove(testName.replace(/ /g,'').replace(/_/g,'').replace(/-/g,''))
    },
	  log: function(value) { console.log(value) },
    signUp: function() {
      if (!this.validate()) {
        return null;
      }
      this.errored = false
      AmplifyEventBus.$emit('loginErrors', {source: 'signUp', error: ''})

      let user = {
        attributes: {},
      };

      // puts field data into 'Auth.signUp' parameter structure
      this.options.signUpFields.forEach((e) => {
        if (e.key === 'username') {
          user.username = e.value
        } else if (e.key === 'password') {
          user.password = e.value
        } else if (e.key === 'phone_number' && e.value) {
          user.attributes.phone_number = `+${this.countryCode}${e.value}`
        } else if (e.value) {
          const newKey = `${this.needPrefix(e.key) ? 'custom:' : ''}${e.key}`;
          user.attributes[newKey] = e.value;
        };
      })
      this.flow = true
      let meta;
      try {
      meta = sessionStorage.getItem('devicemeta')
      if ( meta ) user.clientMetadata = { meta: meta }
      }
      catch(err) {
      console.log('meta parsing', err)
      }
       this.$Amplify.Auth.signUp(user)
            .then(data => {
              this.flow = false;
              this.logger.info('sign up success');
              user.username = data.user.username
              AmplifyEventBus.$emit('localUser', user)
              if (data.userConfirmed === false){
                return AmplifyEventBus.$emit('authState', 'confirmSignUp');
              }
              return AmplifyEventBus.$emit('authState', 'signIn')
            })
            .catch(e => {
      this.flow = false
            this.setError(e)
            });

    },
    validate: function() {
      let invalids = [];
      let w = this;
      this.options.signUpFields.map((el) => {
        if ( w[el.key] ) el.value = w[el.key]
        if (el.required && !el.value) {
          invalids.push(el.label);
          Vue.set(el, 'invalid', true);
        }
        return el;
      })
      if (invalids.length > 0) {
        this.setError(`The following fields must be completed: ${invalids.join(', ')}`)
      }
      return invalids.length < 1;
    },
    signIn: function() {
      this.errored = false
      AmplifyEventBus.$emit('loginErrors', '')
      AmplifyEventBus.$emit('authState', 'signIn')
    },
    clear(field) {
      if (field && field.invalid && field.value) {
        Vue.set(field, 'invalid', false)
      }
    },
    setError: function(e) {
      this.error = this.$Amplify.I18n.get(e.message || e);
      this.errored = true;
      let loginErrors = e.message || e
      try {
      loginErrors = loginErrors.replace(/^.*failed with error/,'')
      }
      catch(err) {
      }
      AmplifyEventBus.$emit('loginErrors', { source: 'signUp', error: loginErrors})
      this.logger.error(this.error)
    },

    // determines whether or not key needs to be prepended with 'custom:' for Cognito User Pool custom attributes.
    needPrefix: function(key) {
      const field = this.options.signUpFields.find(e => e.key === key);
      if (key.indexOf('custom:') !== 0) {
        return field.custom ;
      } else if (key.indexOf('custom:') === 0 && field.custom === false) {
          this.logger.warn('Custom prefix prepended to key but custom field flag is set to false');
      }
      return null;
    },
  }
}
</script>
<style>
#auth input.phoneNumber {
-webkit-appearance: none;
-moz-appearance: textfield;
}
#auth .countryCode select {
flex-basis: unset;
width: 0;
}
.sign-up-section .label-username {
cursor: pointer;
}
</style>

